@import (reference) '../../../../constants/spacing.module.less';

.label-provider-logo {
  height: 48px;
  width: 48px;
  background: var(--default--background-color-19);
  border-radius: 4px;
  padding: @space-4;

  > img {
    height: 100%;
    width: 100%;
    border-radius: 4px;
  }

  &.is-disabled {
    opacity: 0.5;
  }
}

.empty-label-provider-logo {
  width: 48px;

  > svg {
    color: var(--default--icon--fill-color--12);
  }
}

.voided-mas-label-provider-logo {
  display: flex;
  width: 48px;
  height: 48px;
  padding: @space-8;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: var(--success--hover--background-color--2);

  > svg {
    width: 32px;
    height: 32px;
    color: var(--success--icon--fill-color--1);
  }
}
